import React from "react";
import { Form, Row, Col } from "antd";
import ControlledInput from "../../components/Backoffice/ControlledInput";
import ControlledSelect from "../../components/Backoffice/ControlledSelect";
import ControlledFileInput from "../../components/Backoffice/ControlledFileInput";
import FormSection from "../../components/Backoffice/FormSection";
import {
  getCountryOptions,
  getStateOptions,
  getCityOptions,
} from "../../utils/form";

const AddLogisticsForm = ({
  options = {},
  control,
  watch,
  errors,
  edit = false,
  setValue,
}) => {
  const { states = [], cities = [], countries = [] } = options;
  const addressCountry = watch("address.country");
  const addressState = watch("address.state");

  return (
    <Form colon={false}>
      <FormSection heading="Basic Information">
        <Row gutter={24}>
          <Col span={12}>
            <ControlledInput
              required
              control={control}
              name="name"
              label="Registered Name"
              errors={errors}
            />
          </Col>
        </Row>
      </FormSection>
      <FormSection heading="Registered Address">
        <Row gutter={24}>
          <Col span={12}>
            <ControlledInput
              required
              control={control}
              name="address.addressLine1"
              label="Address Line 1"
              errors={errors}
            />
          </Col>
          <Col span={12}>
            <ControlledInput
              control={control}
              name="address.addressLine2"
              label="Address Line 2"
              errors={errors}
            />
          </Col>
        </Row>
        <Row gutter={24}>
          <Col span={12}>
            <ControlledSelect
              required
              control={control}
              name="address.country"
              label="Country"
              options={getCountryOptions(countries)}
              customChange={() => {
                setValue("address.state", "");
                setValue("address.city", "");
              }}
              errors={errors}
            />
          </Col>
          <Col span={12}>
            <ControlledSelect
              required
              control={control}
              name="address.state"
              label="State"
              options={getStateOptions(states, addressCountry)}
              customChange={() => {
                setValue("address.city", "");
              }}
              errors={errors}
            />
          </Col>
        </Row>
        <Row gutter={24}>
          <Col span={12}>
            <ControlledSelect
              required
              control={control}
              name="address.city"
              label="City"
              options={getCityOptions(cities, addressState)}
              errors={errors}
            />
          </Col>
          <Col span={12}>
            <ControlledInput
              required
              control={control}
              name="address.pincode"
              label="Pincode"
              errors={errors}
            />
          </Col>
        </Row>
      </FormSection>
      <FormSection heading="Point of Contact">
        <Row gutter={24}>
          <Col span={12}>
            <ControlledInput
              required
              control={control}
              name="pocName"
              label="PoC Name"
              errors={errors}
            />
          </Col>
          <Col span={12}>
            <ControlledInput
              required
              control={control}
              name="pocContact"
              label="PoC Phone"
              errors={errors}
            />
          </Col>
        </Row>
      </FormSection>
      <FormSection heading="Operations">
        <Row gutter={24}>
          <Col span={12}>
            <ControlledSelect
              required
              multiple
              control={control}
              name="operatingStates"
              label="Operating States"
              options={getStateOptions(states, addressCountry)}
              errors={errors}
            />
          </Col>
        </Row>

        <Row gutter={24}>
          {!edit && (
            <Col span={12}>
              <ControlledFileInput
                control={control}
                name="contract"
                label="Upload Contract"
                errors={errors}
              />
            </Col>
          )}
          <Col span={12}>
            <ControlledInput
              control={control}
              name="remarks"
              label="Remarks"
              errors={errors}
            />
          </Col>
        </Row>
      </FormSection>
    </Form>
  );
};

export default AddLogisticsForm;
